import React, { Suspense } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router';
import routes from './routes';

const App = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <RouterProvider router={createBrowserRouter(routes)} />
    </Suspense>
  );
};

export default App;
